export default __webpack_public_path__ + "static/media/줄간격_아이콘.948597c0.svg";